import React, { useState } from 'react';
import { Button, message } from 'antd';
import dayjs from 'dayjs';
import ExerciseTable from './atoms/exercise_table';
import axios from 'axios';

const Exercises = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [clicked, setClicked] = useState(null);
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'space-between',
      }}
    >
      {contextHolder}
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '4.6rem',
          alignItems: 'center',
          padding: '0rem 1rem 0rem 1rem',
          background: 'rgba(115, 103, 240, 0.16)',
          border: '1px solid rgba(115, 103, 240, 0.16)',
          borderRadius: '0.6rem',
          // font
          fontFamily: 'Public Sans',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '1.5rem',
          lineHeight: '2.2rem',
          color: '#7367F0',
        }}
      >
        {`시퀀스 생성 시 Act에 추가되는 운동 리스트`}
      </div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '100%',
          marginTop: '2.6rem',
          background: '#FFF',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: '5.6rem',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0rem 2.4rem 0rem 2.4rem',
            // font
            fontFamily: 'Public Sans',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '1.8rem',
            lineHeight: '2.4rem',
          }}
        >
          <div>{`운동 리스트`}</div>        
          <Button
            type="primary"
            // htmlType={'submit'}
            // loading={loading}
            style={{
              display: 'flex',
              width: '21.3rem',
              height: '3.4rem',
              justifyContent: 'center',
              alignItem: 'center',
              background: '#7367F0',
              // font
              fontWeight: 600,
              fontSize: '1.5rem',
              lineHeight: '2.2rem',
            }}
            onClick={(e) => {
              setClicked(dayjs().format('YYYYMMDD HH:mm:sss'));
              // navigate(`/exercises/new`, {
              //   replace: true,
              //   state: {
              //     current,
              //     total,
              //     sorts,
              //   },
              // });
            }}
          >
            {`새로운 카테고리 및 영상 추가`}
          </Button>
        </div>
        <ExerciseTable {...props} clicked={clicked} messageApi={messageApi} />
      </div>
    </div>
  );
};

export default Exercises;
